import { render } from "./color-filter.vue?vue&type=template&id=4d02221e&scoped=true&ts=true"
import script from "./color-filter.vue?vue&type=script&lang=ts"
export * from "./color-filter.vue?vue&type=script&lang=ts"

import "./color-filter.vue?vue&type=style&index=0&id=4d02221e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d02221e"]])

export default __exports__